/** Dev/test streams (POST /videos/static). Shown in dev builds or with VITE_ENABLE_TEST_STREAMS=true. */
export const TEST_STREAMS_ENABLED =
  import.meta.env.DEV || import.meta.env.VITE_ENABLE_TEST_STREAMS === 'true';

export const TEST_STREAMS = [
  { label: 'Big Buck Bunny (10 min)', value: 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8' },
  { label: 'Short clip (2 min)', value: 'https://test-streams.mux.dev/pts_shift/master.m3u8' },
];

// Remember for the session when the server says test streams aren't available here.
let unavailable = false;
export function markTestStreamsUnavailable() {
  unavailable = true;
}
export function testStreamsUnavailable() {
  return unavailable;
}
